import { type GooglePlacesApiExtractedAddress } from '@service-initiation/tech-care-data-access-store';

const extractedPropertyOrder: (keyof GooglePlacesApiExtractedAddress)[] = [
  'streetAddress',
  'address2',
  'city',
  'state',
  'zip',
];

export const extractedAddressToFullString = (
  address?: GooglePlacesApiExtractedAddress
) => {
  if (!address || !address.streetAddress) return '';

  const addressString = extractedPropertyOrder
    .map((key) => address[key])
    .filter((value) => value)
    .join(', ');

  return addressString;
};
